import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "../css/Login.module.css";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [toast, setToast] = useState({ open: false, severity: "error", message: "" });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });

      if (!response.ok) {
        throw new Error("Unable to send the reset email.");
      }

      // Always show a neutral success state. The API should use the same response for
      // registered and unregistered addresses to avoid revealing account information.
      setIsSent(true);
    } catch (error) {
      setToast({
        open: true,
        severity: "error",
        message: "We could not send the reset email. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container__login} aria-label="Forgot password page">
      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={() => setToast((current) => ({ ...current, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={toast.severity} variant="filled">{toast.message}</Alert>
      </Snackbar>
      <div className={styles.container__company}>
        <span className={styles.label__company}> by</span>
        <img className={styles.logo__company} src="/assets/img/logo_dicapta.png" alt="Dicapta" />
      </div>
      <div className={styles.container}>
        <div className={styles.header}>
          <figure className={styles.logo}>
            <img src="/assets/img/LogoLogin.png" alt="All 4 Voicing" />
          </figure>
        </div>
        <main className={styles.main}>
          {isSent ? (
            <section className={styles.authMessage} aria-live="polite">
              <h1>Check your email</h1>
              <p>
                If an account exists for <strong>{email}</strong>, you will receive a password reset link shortly.
              </p>
              <p>The link will expire for security reasons.</p>
              <Link to="/login" className={styles.backToLogin}>Back to log in</Link>
            </section>
          ) : (
            <form className={styles.container__formGroup} onSubmit={handleSubmit}>
              <section className={styles.authIntro}>
                <h1>Forgot your password?</h1>
                <p>Enter your email address and we will send you a secure link to reset your password.</p>
              </section>
              <div className={styles.formGroup}>
                <label htmlFor="reset-email" className={styles.formGroup__label}>Email</label>
                <input
                  type="email"
                  id="reset-email"
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  className={styles.formGroup__input}
                  aria-label="Email address"
                  required
                  autoFocus
                  autoComplete="email"
                />
              </div>
              <div className={[styles.formGroup, styles.save].join(" ")}>
                <div className={styles.container__btnLogin}>
                  <button type="submit" className={styles.btnLogin} disabled={isSubmitting}>
                    {isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Send reset link"}
                  </button>
                  <Link to="/login" className={styles.forgotPassword}>Back to log in</Link>
                </div>
              </div>
            </form>
          )}
        </main>
      </div>
    </div>
  );
};
